import { render, staticRenderFns } from "./SmsType.vue?vue&type=template&id=998ab9e4&scoped=true&"
import script from "./SmsType.vue?vue&type=script&lang=js&"
export * from "./SmsType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "998ab9e4",
  null
  
)

export default component.exports